export default __webpack_public_path__ + "images/assets/edf2bae11d35d7c3a216b64ec9018dc7.svg";